import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

interface DeleteModalProps {
  title: string;
  objectName: string;
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  refetchClients?: () => void;
}

const DeleteModal: FC<DeleteModalProps> = ({ title, objectName, isOpen, onClose, onDelete, refetchClients }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Modal isOpen={isOpen} toggle={onClose} size="md">
        <ModalHeader className="border-bottom pt-3 pb-2" toggle={onClose}>
          <div className="text-purple">{title}</div>
        </ModalHeader>
        <ModalBody>
          {t('Modals.delete-modal.msg')}
          <span className="text-danger fs-16">{` ${objectName} `}</span>?
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              onClose();
            }}
            className="btn btn-ghost-danger"
          >
            {t('Modals.delete-modal.cancel')}
          </Button>{' '}
          <Button
            className="btn btn-ghost-success"
            onClick={() => {
              onDelete();
              onClose();
              refetchClients && refetchClients();
            }}
          >
            {t('Modals.delete-modal.delete')}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DeleteModal;
